var vms = vms || {};
vms.file = vms.file || {};


//Document management files notes
vms.file.fileNotes = function (pId, pType) {
    if (pType == 'FILE_SEQ') { vTag = 'uiFileSeq'; }
    else if (pType == 'FILE_FOLDERID') { vTag = 'uiVstId'; }
    else if (pType == 'FILE_COMP_FOLDERID') { vTag = 'uiCofId'; }
    else { vTag = 'uiFileNotes'; }

    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: 'APPLICATION_PROCESS=saveFileNotes',
            x01: pId,
            x02: $v(vTag + pId),
            x03: pType
        },
        success: function (d) {
            if (d == 'NOK') {
                $("#uiFileNotes" + pId).animateHighlight("#EE1111", 1000);
            } else {
                $("#uiFileNotes" + pId).animateHighlight("#00A300", 1000);
            }
        }
    })
}

//Attach documents to entities
vms.file.setDocAttach = function (pAid, pEid, pSid) {
    $.post(
        'wwv_flow.show', {
            "p_request": 'APPLICATION_PROCESS=setFileAttachment',
            "p_flow_id": $v('pFlowId'), //app id
            "p_flow_step_id": $v('pFlowStepId'), //page id
            "p_instance": $v('pInstance'), //session id
            "x01": pAid,
            "x02": pEid,
            "x03": pSid
        },
        function (data) {
            apex.submit("ATTACHEMENTS");
			apex.navigation.dialog.close(true);
        }
    );
}

//Delete attached documents
vms.file.delDocAttach = function (pRid, pSid, pEid) {
    $.post(
        'wwv_flow.show', {
            "p_request": 'APPLICATION_PROCESS=delFileAttachment',
            "p_flow_id": $v('pFlowId'), //app id
            "p_flow_step_id": $v('pFlowStepId'), //page id
            "p_instance": $v('pInstance'), //session id
            "x01": pRid
        },
        function (ret) {
            //redirect('f?p=' + $v('pFlowId') + ':251:' + $v('pInstance') + '::NO::P251_SRC_REC_ID,P251_SRC_ETY_ID:' + pSid + ',' + pEid);
			var i=ret.indexOf('~');
			var cnt=ret.substr(0,i);
			var afgId=ret.substr(i+1);
            apex.submit("ATTACHEMENTS");
			if (cnt==0) {
				if (confirm('WARNING: this file will be permanently deleted from the app. Are you sure you want to continue?')) {
					vms.file.delete(afgId);
				}
			}
        }
    );
}

/* Created on 29.03.2021 by Davor 
vms.file.refreshParent(pEid);
window.parent.vms.file.refreshParent(pEid);
*/
vms.file.refreshParent = function (pEid){
    console.log(pEid);
    switch (pEid) {
        case 55://FLDR_CRT_EQP
            apex.region("pgIR1").refresh();
            break;
        default:
            break;
    }
}

//Delete Files
vms.file.delete = function (pAfgId) {
    $.post(
        'wwv_flow.show', {
            "p_request": 'APPLICATION_PROCESS=deleteFiles',
            "p_flow_id": $v('pFlowId'), //app id
            "p_flow_step_id": $v('pFlowStepId'), //page id
            "p_instance": $v('pInstance'), //session id
            "x01": pAfgId
        },
        function (data) {
            apex.message.showPageSuccess( "File is deleted." );
        }
    );
}

var fileNotes = vms.file.fileNotes;
var setDocAttach = vms.file.setDocAttach;
var delDocAttach = vms.file.delDocAttach;